(function(root, factory) {

    // NOTE: Adapted from: https://github.com/umdjs/umd/blob/master/templates/returnExports.js
    // Until we move the webpack, we still need to use the amd format for core's r.js
    // The client side doesn't really need lazy string, but RRS would throw an error during
    // checksum validation if client side code doesn't match server side
    if (typeof define === 'function' && define.amd && root.gettext) {
        define(['js-utils/lazy-gettext/GenericLazyString'], function(GenericLazyString) { // eslint-disable-line prefer-arrow-callback
            return factory(root.gettext, GenericLazyString);
        });
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('../gettext'), require('./GenericLazyString'));
    }

})(this, function(gettext, GenericLazyString) { // eslint-disable-line babel/no-invalid-this, prefer-arrow-callback

    /**
     * LazyString is a constructor functions that inherits from GenericLazyString. The difference with GenericLazyString
     * is that in this case, we want it to be bound to 'gettext()'.
     * Ideally this class should be named something like "GettextLazyString", but we are keeping the current name because
     * changing this will probably be a breaking change and should be done more carefully.
     *
     * @param {string} msgid the message or template string
     * @param {object} interpolation an object containing the values to be used in the template string
     */
    function LazyString(msgid, interpolation) {
        function translateFn() {
            return gettext(msgid, interpolation);
        }

        /*
          Here we call GenericLazyString's constructor, passing in 'this' (the current instance of LazyString in process of being created)
          so that all initialization setup from GenericLazyString is applied to this instance too.
          This is the 'old style' of what you nowadays would do in ES6 classes with just a call to 'super()'
        */
        GenericLazyString.call(this, translateFn);
    }

    /* This is what makes GenericLazyString satisfy the 'instanceof' LazyString */
    LazyString.prototype = GenericLazyString.prototype;

    /* This is not strictly necessary, but will make it easier to debug and seems to be a good practice */
    LazyString.prototype.constructor = LazyString;

    /* We consider any instance of LazyString valid if they are instances of GenericLazyString */
    LazyString.isValid = GenericLazyString.isValid;

    return LazyString;
});
